// extracted by mini-css-extract-plugin
export default {"matSelect":"Multiselect_matSelect__i5CMu","select":"Multiselect_select__vy3nq"};